import { render } from "./Alignment.vue?vue&type=template&id=84bd36d0"
import script from "./Alignment.vue?vue&type=script&lang=ts"
export * from "./Alignment.vue?vue&type=script&lang=ts"
script.render = render

export default script